module.exports = __webpack_public_path__ + "static/media/duetigli-sangiovese.14493d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/duetigli-sangiovese.png
// module id = 795
// module chunks = 0